module.exports = __webpack_public_path__ + "/content/skins/chase-maserati/fonts/Everett-Thin-web.woff2";